import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./yearGroup.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IYearGroup } from "./IyearGroup";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import YearGroupForm from "./yearGroupForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listyearGroup } from "../../Redux/Slices/yearGroup/ListyearGroupSlice";
import { clearAddyearGroupResponse } from "../../Redux/Slices/yearGroup/AddyearGroupSlice";
import {
  clearDeleteyearGroupResponse,
  deleteyearGroup,
} from "../../Redux/Slices/yearGroup/DeleteyearGroupSlice";
import { clearEdityearGroupResponse } from "../../Redux/Slices/yearGroup/EdityearGroupSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { Console } from "console";

interface yearGroupProps {}

const YearGroup: FunctionComponent<yearGroupProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IYearGroup | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listyearGroups } = useAppSelector(
    (state) => state.ListyearGroupSlice
  );
  const { data: addyearGroup } = useAppSelector(
    (state) => state.AddyearGroupSlice
  );
  const { data: EdityearGroup } = useAppSelector(
    (state) => state.EdityearGroupSlice
  );
  const { data: deleteyearGroups } = useAppSelector(
    (state) => state.DeleteyearGroup
  );
  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );

  const to = "masters";

  const filteredList = userPermissionlist.Dashboard.filter(
    (item: any) => item.to === to
  );
  const fliterdata: any = filteredList[0]?.items;
  const finaldata = fliterdata[0];

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "year_group",
      renderHeader: () => <b>Year Group</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },

    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IYearGroup>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row });
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.year_group });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const yearGroup = Array.isArray(listyearGroups?.data)
    ? listyearGroups?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  useEffect(() => {
    dispatch(listyearGroup());
    // dispatch(listSideMenuPermission());
  }, [addyearGroup, EdityearGroup, deleteyearGroups, dispatch]);
  useEffect(() => {
    console.log("List of Year Groups:", listyearGroups?.data); // Log the data listing
  }, [listyearGroups]);

  useEffect(() => {
    return () => {
      dispatch(clearAddyearGroupResponse());
      dispatch(clearEdityearGroupResponse());
      dispatch(clearDeleteyearGroupResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={yearGroup ?? []} columns={columns}>
        <CustomToolbar>
          {/* <h6>year group</h6> */}
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              console.log("Opening dialog to add new year group"); // Log for adding new data
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listyearGroup())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog"
        Dialog_Title={`${
          (initialValues as IYearGroup).id ? "Update" : "Add"
        } yeargroup`}
        dialogContentClassName="dialog_content"
        Dialog_Content={
          <YearGroupForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                console.log("Save button clicked. Submitting the form."); // Log for save button click
                formRef.current?.requestSubmit();
              }}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addyearGroup} parentDialog={setDialogOpen} />
      <ResponseDialog response={EdityearGroup} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteyearGroup(deleteDialogData.id));
        }}
        response={deleteyearGroups}
      />
    </>
  );
};

export default YearGroup;
